import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

async function getB2CServiceHistoryRequestQuery(apiClient: ApiClient, id: number | undefined) {
  return apiClient.GET(`/op/v2/b2c-service-history-request/{id}`, { params: { path: { id: id! } } });
}

export default function useB2CServiceHistoryRequestQuery(id: number | undefined) {
  const toast = useToast();
  const apiClient = useApiClient();

  const query = useQuery({
    queryKey: getKey(id),
    queryFn: () => throwOnError(getB2CServiceHistoryRequestQuery(apiClient, id)),
    enabled: !!id,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id: number | undefined): QueryKey {
  return ['B2CServiceHistoryRequest', id] as const satisfies QueryKey;
}

useB2CServiceHistoryRequestQuery.getKey = getKey;
